import React from 'react';
import { assets } from '../../../assets';
import Button from '../../buttons/button';
import { ControlsContainer, FilterIcon, HeaderContainer, ButtonContainer } from './components';
import useListHeader from './hooks';

const ListHeader = (props: {
  onCreateClick: () => void;
  createButtonLabel: string;
  children?: React.ReactNode;
}): JSX.Element => {
  const { filtersVisible, handleFilterClick } = useListHeader();

  return (
    <HeaderContainer>
      <ControlsContainer
        className="flex flex-col sm:flex-row sm:items-center"
        visible={filtersVisible}
      >
        {props.children}
      </ControlsContainer>
      <FilterIcon
        src={assets.icons.filter_icon}
        alt="filter"
        className="cursor-pointer sm:hidden"
        onClick={handleFilterClick}
      />
      <ButtonContainer className="full-width-mobile">
        <Button fullWidthMobile onClick={props.onCreateClick}>
          {props.createButtonLabel}
        </Button>
      </ButtonContainer>
    </HeaderContainer>
  );
};

export default ListHeader;
